import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const BarangLepasGabungPage = lazy(() => import('./pages/barang-lepas-gabung'))
const DetailPermintaanGabungPage = lazy(() => import('./pages/detail-permintaan-gabung'))
const PenggabunganOperatorPage = lazy(() => import('./pages/penggabungan-operator'))
const KonsolidasiPalletPage = lazy(() => import('./pages/konsolidasi-pallet'))
const KonsolidasiOperatorPage = lazy(() => import('./pages/konsolidasi-operator'))

/** Cluster C10 Merge & Konsolidasi FG — GAB-01 (+detail), GAB-02, KSL-01, KSL-02. */
const mergeConsolidationFgRoutes: RouteObject[] = [
  {
    path: 'merge-consolidation-fg',
    children: [
      {
        path: 'barang-lepas-gabung',
        children: [
          { index: true, element: <BarangLepasGabungPage /> },
          { path: ':id', element: <DetailPermintaanGabungPage /> }
        ]
      },
      { path: 'penggabungan-operator', element: <PenggabunganOperatorPage /> },
      { path: 'konsolidasi-pallet', element: <KonsolidasiPalletPage /> },
      { path: 'konsolidasi-operator', element: <KonsolidasiOperatorPage /> }
    ]
  }
]

export default mergeConsolidationFgRoutes
